import styles from "./ArticleCard.module.scss";
// import Image from "~/components/atoms/Image"
import PropTypes from "prop-types";
import dayjs from "dayjs";
import { getUrl, getTag } from "~/utils/Blog/Post";
import { getUrl as getTagUrl } from "~/utils/Blog/Tag";
import Link from "next/link";

const ArticleCard = ({ post, minimal, group }) => {
  const date = dayjs(post.published_at);

  const classNames = [styles["ArticleCard"], minimal ? styles["--minimal"] : ""]
    .join(" ")
    .trim();

  const tag = getTag(post);
  const url = getUrl(post, group);
  const tagUrl = getTagUrl(tag);

  return (
    <div className={classNames}>
      <Link href={url} className={styles["ArticleCard__image-container"]}>
        <div className={styles["ArticleCard__image"]}>
          <picture>
            <img
              width={326}
              height={183}
              src={post.feature_image}
              alt={post.feature_image_alt}
            />
          </picture>
        </div>
      </Link>
      <Link href={url} className={styles["ArticleCard__content-container"]}>
        <div className={styles["ArticleCard__content"]}>
          <h2 className={styles["ArticleCard__heading"]}>{post.title}</h2>
          {!minimal && (
            <p className={styles["ArticleCard__excerpt"]}>
              {post?.custom_excerpt || post.excerpt}
            </p>
          )}
        </div>
      </Link>
      <div className={styles["ArticleCard__meta"]}>
        <div className={styles["ArticleCard__meta-author"]}>
          {!minimal && post?.primary_author?.profile_image && (
            <img
              src={post.primary_author.profile_image}
              height={32}
              width={32}
            />
          )}
          <div>
            {!minimal && post.primary_author && (
              <div className={styles["ArticleCard__meta-author-name"]}>
                {post.primary_author.name}
              </div>
            )}
            <time
              className={styles["ArticleCard__meta-timestamp"]}
              dateTime={`${date.format("YYYY")}-${date.format(
                "MM"
              )}-${date.format("DD")}`}
              title={`${date.format("DD")} ${date.format("MMM")} ${date.format(
                "YYYY"
              )}`}
            >
              {date.format("DD")} {date.format("MMM")} {date.format("YYYY")}
            </time>
          </div>
        </div>
        {!minimal && tag?.name && (
          <ul className={styles["ArticleCard__meta-tags"]}>
            <li key={tag.id}>
              <Link href={tagUrl}>{tag.name}</Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

ArticleCard.propTypes = {
  minimal: PropTypes.bool,
  post: PropTypes.object,
};

ArticleCard.defaultProps = {
  minimal: false,
  post: {},
};

export default ArticleCard;
